var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.031,
    height: 19.031,
    viewBox: "0 0 19.031 19.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_7793",
    "data-name": "Tracciato 7793",
    d: "M3380.122,3912.846h-7.148V3905.7a1.183,1.183,0,1,0-2.367,0v7.148h-7.148a1.183,1.183,0,1,0,0,2.367h7.148v7.149a1.183,1.183,0,0,0,2.367,0v-7.149h7.148a1.183,1.183,0,0,0,0-2.367",
    transform: "translate(-3362.274 -3904.514)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.f4b26e485b144821173d645285578c72.svg";
export { ForwardRef as ReactComponent };